import React, {useEffect, useState} from 'react';
import CircularProgress from '@material-ui/core/CircularProgress'
import WarningModal from '../components/modal'

interface PayoutsProps{
    type:string;
    phoneNumber: string;
    amount:string;
    accNo?:string;
    ifsc?:string;
    user?:string;
    membershipID?: string;
    handleToUpdateStatus: Function;
    coupon?:string;
    prevBankUUID: Array<any>;
}

export const Payouts: React.FC<PayoutsProps> = (props: PayoutsProps) => {

  const [loading, setLoading] = useState(false)
  const [locationBlocked, setLocationBlocked] = useState(false)

  const{
    handleToUpdateStatus, phoneNumber, amount, type, accNo, ifsc, user, membershipID, coupon, prevBankUUID
  } = props;

  const axios = require('axios').default;

  const HOST = process.env.REACT_APP_HOST;
  const API = process.env.REACT_APP_API;
  const AZURE_HOST = process.env.REACT_APP_AZURE_HOST;
  const REACT_APP_AZURE_HOST_PAYTM_PROD = process.env.REACT_APP_AZURE_HOST_PAYTM_PROD;
  const REACT_APP_AZURE_HOST_PAYTM_UAT = process.env.REACT_APP_AZURE_HOST_PAYTM_UAT;
  const REACT_APP_AZURE_HOST_BANK_PROD = process.env.REACT_APP_AZURE_HOST_BANK_PROD;
  const REACT_APP_AZURE_HOST_BANK_UAT = process.env.REACT_APP_AZURE_HOST_BANK_UAT;

  const path = window.location.pathname;
  const pathParams = path.split('/')

  const message ='Something went wrong. Please Retry.'

  const heading = "Location Disabled !!"
  const content = "Please allow location services"


const statusCheck = async (code: any, message: string, orderId:string, razor_transaction_id?:string) => {
  
  if (code === 'DE_001') {
    handleToUpdateStatus('SUCCESS', "success", orderId, '-' );
  } 
  else if(code === 'processed' || code === 'SUCCESS') {
    handleToUpdateStatus('SUCCESS', "success", orderId, razor_transaction_id, '-' );
  }
  else if(code === 'queued' || code === 'pending' || code === 'processing' || code === 'APPROVAL_PENDING'
    || code === 'PENDING' || code === 'QUEUED' || code === 'RECEIVED'){
    handleToUpdateStatus('PENDING', message, orderId, razor_transaction_id, '-');
  }
  else if(code === 'rejected' || code === 'cancelled' || code === 'reversed' || code === 'FAILED'
    || code === 'MANUALLY_REJECTED' || code === 'REJECTED' || code === 'REVERSED'){
    handleToUpdateStatus('FAILURE', message, orderId, razor_transaction_id, '-');
  }
  else if(code === 'DE_101' || code === 'DE_102'){
    handleToUpdateStatus('PENDING', message, orderId, '-');
  }
  else{
    return  handleToUpdateStatus('FAILURE', message, orderId, '-');
  }
}

const initiateWalletTransaction = async (a:any, b:any, pincode:any, city:any) => {
  setLoading(true);
  axios
    .post( `${REACT_APP_AZURE_HOST_PAYTM_PROD}`,{
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1]
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data
    statusCheck(data.statusCode, data.statusMessage, response.data.orderId)
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') 
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
}

const initiateBankTransaction = async (a:any, b:any, pincode:any, city:any) => {
  setLoading(true);
  return axios
    .post( `${HOST}${API}initiate-cashfree-bank-transaction/`,
      prevBankUUID[1] === "from_old_bank" ? {
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1],
      from_old_bank: prevBankUUID[1] === "from_old_bank" && true,
      bank_uuid: prevBankUUID[0],
      is_bank: true,
      beneficiaryName: "test"
    } : 
    {
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      amount: amount,
      ifsc: ifsc,
      accountNumber: accNo,
      coupon: coupon,
      membershipId: membershipID,
      userType: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1],
      is_bank: true,
      beneficiaryName: "test"
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data
    statusCheck(data.status, data.status_description, data.transfer_id, data.cf_transfer_id)
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') //HANDLE INVALID IFSC
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
}

const initiatePointsTransaction = async (a:any, b:any, pincode:any, city:any) => { //change body  
  setLoading(true);
  return axios
    .post( `${HOST}${API}initiate-points-transaction/`,{
      phoneNumber: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNumber,
      membershipId: membershipID,
      coupon: coupon,
      amount: amount,
      user: user,
      user_latitude: a,
      user_longitude: b,
      user_pincode: pincode,
      user_city: city,
      product: pathParams[1]
    },
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  )
  .then((response: any) => {
    setLoading(false);
    const data = response.data.data.data[0]
    
    if(response.data.data.data[0].resultCode === "0"){
      handleToUpdateStatus("SUCCESS", "success", response.data.orderId, '-')
    }
    else{
      handleToUpdateStatus("FAILURE", data.resultDescription, response.data.orderId, '-')
    }
  })
  .catch((err: any) => {
    var dispMess = err.response;
    setLoading(false);
    if(dispMess.status === 400) {
      if(dispMess.data.message) {
        handleToUpdateStatus('RESPONSE_MESSAGE', dispMess.data.message, '-', '-')
      }
      else {
        handleToUpdateStatus('FAILURE', message, '-', '-') 
      }
    }
    else {
      handleToUpdateStatus('BLOCKUSER', "Something went wrong please try again.", '-', '-') 
    }
  });
}

useEffect( () => {
    if(type === 'wallet'){
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }

      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                        var pincode;
                        var city;
                        for (var j = 0; j < results[0].address_components.length; j++) {
                          if (results[0].address_components[j].types[0] === 'postal_code') {
                              pincode = results[0].address_components[j].long_name
                          }
                          if (results[0].address_components[j].types[0] === 'locality') {
                              city = results[0].address_components[j].long_name
                          }
                        }                      
                        initiateWalletTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      }
    }
    else if(type === 'bank'){       
      if (navigator.permissions && navigator.permissions.query) { 
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }
      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                    var pincode;
                    var city;
                    for (var j = 0; j < results[0].address_components.length; j++) {
                      if (results[0].address_components[j].types[0] === 'postal_code') {
                          pincode = results[0].address_components[j].long_name
                      }
                      if (results[0].address_components[j].types[0] === 'locality') {
                          city = results[0].address_components[j].long_name
                      }
                    }                         
                      initiateBankTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      }
    }
    else if(type === 'points'){
      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({
          name: 'geolocation'
      }).then(function(result) {
          if (result.state === 'denied') {
              setLocationBlocked(true)
          }
      });
    }

      if(locationBlocked === false) {
      navigator.geolocation.getCurrentPosition((pos) => {
        var geocoder = new google.maps.Geocoder();
            var latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
            geocoder.geocode({ 'location': latlng }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results[0]) {
                      var pincode;
                      var city;
                      for (var j = 0; j < results[0].address_components.length; j++) {
                        if (results[0].address_components[j].types[0] === 'postal_code') {
                            pincode = results[0].address_components[j].long_name
                        }
                        if (results[0].address_components[j].types[0] === 'locality') {
                            city = results[0].address_components[j].long_name
                        }
                      }                      
                        initiatePointsTransaction(pos.coords.latitude, pos.coords.longitude, pincode, city);
                }
            })
      }) 
    }
      else {
        setLocationBlocked(true)
      } 
    }
  }, [])

return (
  <div>
    {
        loading &&
        <div className='main-loader'>
          <CircularProgress />
        </div>
    }
    {
      locationBlocked && <WarningModal heading={heading} content={content} />
    }
  </div>
);
}

export default Payouts